import { useEffect } from 'react';
import { insertTrackableHTML } from 'js/utils/DOM.util';
import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

export const CustomHtml = ({ config, tagName }) => {
    const { beforeEndHead, beforeEndBody } = config;

    useEffect(() => {
        if (beforeEndBody === '') {
            return;
        }

        return insertTrackableHTML({ selector: 'body', html: beforeEndBody, tagName });
    }, [beforeEndBody, tagName]);

    useEffect(() => {
        if (beforeEndHead === '') {
            return;
        }

        return insertTrackableHTML({ selector: 'head', html: beforeEndHead, tagName });
    }, [beforeEndHead, tagName]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.customHtml]: CustomHtml });
